import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import SectionHeader from '../components/common/SectionHeader';
import CtaSection from '../components/common/CtaSection';
import Icon from '../components/common/Icon';
import Breadcrumbs from '../components/common/Breadcrumbs';

const ChiSiamoPage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Chi Siamo' }];


  return (
    <Layout>
      {/* EPIC HERO REDESIGN - ANIMATED */}
      <section className="hero--epic" style={{ perspective: '1000px' }}>
        <div className="hero__bg">
          <div className="hero__image" style={{ 
            backgroundImage: 'url(https://images.unsplash.com/photo-1540910419312-52427b313d66?q=80&w=1600&auto=format&fit=crop)',
            transition: 'transform 1.5s cubic-bezier(0.16, 1, 0.3, 1)'
          }}></div>
          <div className="hero__overlay"></div>
        </div>
        
        <div className="hero__decor">
          <div className="hero__square animate-float" style={{ '--x': '15%', '--y': '25%', '--s': '120px', '--d': '12s', opacity: 0.4 }}></div>
          <div className="hero__square animate-float-slow" style={{ '--x': '85%', '--y': '15%', '--s': '180px', '--d': '18s', opacity: 0.3 }}></div>
          <div className="hero__square animate-float" style={{ '--x': '75%', '--y': '75%', '--s': '150px', '--d': '15s', opacity: 0.4 }}></div>
          <div className="hero__square animate-float-slow" style={{ '--x': '10%', '--y': '80%', '--s': '90px', '--d': '9s', opacity: 0.2 }}></div>
        </div>

        <div className="hero__content-epic container">
          <div className="reveal" style={{ marginBottom: 'var(--space-8)' }}>
            <Breadcrumbs items={breadcrumbs} style={{ color: 'inherit', padding: 0 }} />
          </div>
          
          <h1 className="hero__title-epic text-reveal-trigger">
            <span className="line text-reveal"><span className="word text-reveal__inner" style={{ transitionDelay: '0.1s' }}>Siamo la</span></span>
            <span className="line text-reveal"><span className="word accent text-reveal__inner" style={{ transitionDelay: '0.3s' }}>Nuova Generazione</span></span>
            <span className="line text-reveal"><span className="word text-reveal__inner" style={{ transitionDelay: '0.5s' }}>Democratica.</span></span>
          </h1>
          
          <p className="hero__subtitle-epic reveal stagger-3" style={{ opacity: 1 }}>
            L'organizzazione giovanile del Partito Democratico. Una comunità aperta, coraggiosa e radicale che lotta per un futuro più giusto.
          </p>

          <div className="hero__scroll-indicator reveal stagger-5">
            <div className="mouse"></div>
          </div>
        </div>
      </section>

      {/* MANIFESTO SECTION - ANIMATED */}
      <section className="manifesto-section reveal reveal--scale">
        <div className="container">
          <div className="manifesto-text text-reveal-trigger">
            <span className="text-reveal"><span className="text-reveal__inner">I Giovani Democratici sono</span></span> 
            <span className="text-primary text-reveal"><span className="text-reveal__inner" style={{ transitionDelay: '0.2s' }}>l'energia</span></span> 
            <span className="text-reveal"><span className="text-reveal__inner" style={{ transitionDelay: '0.4s' }}>che trasforma le idee in</span></span> 
            <span className="text-secondary text-reveal"><span className="text-reveal__inner" style={{ transitionDelay: '0.6s' }}>cambiamento reale</span></span>. 
            <br />
            <span className="text-reveal"><span className="text-reveal__inner" style={{ transitionDelay: '0.8s' }}>Presenti in ogni angolo d'Italia, da oltre vent'anni.</span></span>
          </div>
        </div>
      </section>

      {/* VALUES MARQUEE */}
      <div className="marquee-section reveal">
        <div className="marquee-inner">
          {[1, 2, 3, 4].map((set) => (
            <React.Fragment key={set}>
              <span>DEMOCRAZIA</span>
              <span>•</span>
              <span>UGUAGLIANZA</span>
              <span>•</span>
              <span>EUROPA</span>
              <span>•</span>
              <span>LAVORO</span>
              <span>•</span>
              <span>AMBIENTE</span>
              <span>•</span>
              <span>DIRITTI</span>
              <span>•</span>
            </React.Fragment>
          ))}
        </div>
      </div>

      {/* MISSION & STATS - ANIMATED */}
      <section className="section" style={{ background: 'var(--color-bg)', overflow: 'hidden' }}>
        <div className="container">
          <div className="grid grid-2 gap-12 items-center">
            <div className="order-2-md reveal reveal--right">
              <div style={{ position: 'relative' }}>
                <div style={{ borderRadius: 'var(--radius-2xl)', overflow: 'hidden', boxShadow: 'var(--shadow-xl)', transform: 'rotate(2deg)' }}>
                  <img src="https://images.unsplash.com/photo-1523240715637-8a3112a64c4c?q=80&w=1200&auto=format&fit=crop" alt="Collaborazione" style={{ width: '100%', height: '500px', objectFit: 'cover' }} />
                </div>
                {/* Floating Stat Card */}
                <div className="reveal stagger-2" style={{ 
                  position: 'absolute', 
                  bottom: '-30px', 
                  left: '-30px', 
                  background: 'var(--color-surface)', 
                  padding: 'var(--space-6)', 
                  borderRadius: 'var(--radius-xl)',
                  boxShadow: 'var(--shadow-lg)',
                  maxWidth: '240px',
                  zIndex: 2,
                  border: '1px solid var(--color-border-subtle)',
                  transform: 'rotate(-2deg)'
                }}>
                  <div className="h2 text-primary mb-1">25.000+</div>
                  <div className="text-small font-bold text-secondary uppercase tracking-wider mb-2">Iscritti attivi</div>
                  <p className="text-xs text-secondary">La più grande organizzazione politica giovanile in Italia.</p>
                </div>
              </div>
            </div>
            
            <div className="order-1-md reveal reveal--left">
              <span className="section-header__overline">La nostra missione</span>
              <h2 className="h1 mb-6">Protagonisti del nostro tempo.</h2>
              <div className="prose text-lg text-secondary">
                <p>Non aspettiamo che il futuro bussi alla nostra porta. Lo costruiamo ogni giorno attraverso la partecipazione, il confronto e l'azione collettiva.</p>
                <p>Crediamo in una politica che sappia ascoltare i bisogni delle periferie, che difenda i diritti di tutti e che non abbia paura di sfidare lo status quo.</p>
                <div className="grid grid-2 gap-4 mt-8">
                  {[
                    { title: 'Partecipazione', text: 'Democrazia dal basso.', icon: 'Users' },
                    { title: 'Giustizia', text: 'Sociale ed economica.', icon: 'Scale' },
                  ].map((item, idx) => (
                    <div key={item.title} className={`p-4 reveal stagger-${idx + 1}`} style={{ background: '#fff', borderRadius: 'var(--radius-lg)', border: '1px solid var(--color-border-subtle)' }}>
                      <div className="text-primary mb-2"><Icon name={item.icon} size={24} /></div>
                      <h4 className="h6 mb-1">{item.title}</h4>
                      <p className="text-xs">{item.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TIMELINE - MODERNIZED & ANIMATED */}
      <section className="section" style={{ background: 'var(--color-surface-alt)', color: '#fff', overflow: 'hidden' }}>
        <div className="container">
          <div className="section-header text-center items-center reveal">
            <span className="section-header__overline" style={{ color: 'var(--color-primary-light)' }}>La nostra storia</span>
            <h2 className="h1" style={{ color: '#fff' }}>Un percorso di impegno</h2>
          </div>
          
          <div className="timeline-modern reveal" style={{ maxWidth: '900px', margin: '0 auto', position: 'relative', marginTop: 'var(--space-12)' }}>
             <div className="timeline-line" style={{ 
               position: 'absolute', 
               left: '50%', 
               top: 0, 
               bottom: 0, 
               width: '2px', 
               background: 'linear-gradient(to bottom, var(--color-primary), transparent)', 
               transform: 'translateX(-50%)',
               opacity: 0.3
             }}></div>
             
             {[
               { year: '2007', title: 'Nascita dei GD', text: "Con la fondazione del PD nasce ufficialmente la nostra giovanile.", side: 'left' },
               { year: '2010', title: 'Assemblea Nazionale', text: 'Oltre 1000 delegati si riuniscono per definire la linea politica.', side: 'right' },
               { year: '2015', title: 'Radicamento', text: 'I circoli superano quota 500, diventando presidi in tutta Italia.', side: 'left' },
               { year: '2020', title: 'Solidarietà', text: 'Durante la pandemia attiviamo reti di supporto per i più fragili.', side: 'right' },
               { year: '2026', title: 'Oggi', text: "Siamo pronti alle nuove sfide: lavoro, clima e diritti civili.", side: 'left' },
             ].map((item, idx) => (
               <div key={item.year} className={`reveal reveal--${item.side === 'left' ? 'left' : 'right'} stagger-${(idx % 3) + 1}`} style={{ 
                 display: 'flex', 
                 justifyContent: item.side === 'left' ? 'flex-start' : 'flex-end',
                 marginBottom: 'var(--space-12)',
                 position: 'relative'
               }}>
                 {/* Dot */}
                 <div className="timeline-dot" style={{ 
                   position: 'absolute', 
                   left: '50%', 
                   top: '10px', 
                   width: '16px', 
                   height: '16px', 
                   background: 'var(--color-primary)', 
                   borderRadius: '50%', 
                   transform: 'translateX(-50%)',
                   boxShadow: '0 0 15px var(--color-primary)',
                   zIndex: 2
                 }}></div>
                 
                 <div style={{ 
                   width: '45%', 
                   padding: 'var(--space-6)', 
                   background: 'rgba(255,255,255,0.03)', 
                   borderRadius: 'var(--radius-xl)',
                   border: '1px solid rgba(255,255,255,0.08)',
                   backdropFilter: 'blur(10px)',
                   textAlign: item.side === 'left' ? 'right' : 'left',
                   transition: 'all 0.4s ease'
                 }} className="timeline-card">
                   <div className="text-primary font-bold mb-1" style={{ fontSize: '1.5rem' }}>{item.year}</div>
                   <h3 className="h5 mb-2" style={{ color: '#fff' }}>{item.title}</h3>
                   <p className="text-small" style={{ color: 'rgba(255,255,255,0.6)' }}>{item.text}</p>
                 </div>
               </div>
             ))}
          </div>
        </div>
      </section>

      {/* STRUTTURA - PREMIUM CARDS - ANIMATED */}
      <section className="section bg-subtle" style={{ overflow: 'hidden' }}>
        <div className="container">
          <div className="reveal">
            <SectionHeader overline="Struttura" title="Come siamo organizzati" />
          </div>
          <div className="grid grid-3 gap-6">
            {[
              { icon: 'Landmark', title: 'Organizzazione Nazionale', text: 'Segreteria, assemblea, direzione e organismi nazionali.', path: '/organizzazione', color: 'var(--color-primary)' },
              { icon: 'MapPin', title: 'Circoli', text: 'Oltre 850 circoli in tutta Italia.', path: '/circoli', color: 'var(--color-secondary)' },
              { icon: 'Map', title: 'Federazioni', text: '107 federazioni provinciali.', path: '/federazioni', color: 'var(--color-accent)' },
            ].map((item, idx) => (
              <Link to={item.path} className={`card-premium reveal reveal--scale stagger-${idx + 1}`} key={item.title} style={{ 
                padding: 'var(--space-8)', 
                background: '#fff', 
                borderRadius: 'var(--radius-xl)',
                display: 'block',
                transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                border: '1px solid var(--color-border-subtle)',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <div style={{ 
                  width: '60px', 
                  height: '60px', 
                  borderRadius: 'var(--radius-lg)', 
                  background: `${item.color}15`, 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  color: item.color,
                  marginBottom: 'var(--space-6)'
                }}>
                  <Icon name={item.icon} size={30} />
                </div>
                <h4 className="h4 mb-3">{item.title}</h4>
                <p className="text-body-sm text-secondary">{item.text}</p>
                <div style={{ marginTop: 'var(--space-4)', color: item.color, fontWeight: 'bold', fontSize: 'var(--text-xs)', textTransform: 'uppercase', letterSpacing: '0.1em', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  Scopri di più <Icon name="ChevronRight" size={14} />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA - ANIMATED */}
      <section className="section reveal reveal--scale">
        <div className="container">
          <CtaSection title="Vuoi saperne di più?" subtitle="Scopri la nostra organizzazione o trova il circolo più vicino a te.">
            <div className="btn-group reveal stagger-2" style={{ justifyContent: 'center' }}>
              <Link to="/organizzazione" className="btn btn--primary btn--lg btn--glow">Organizzazione</Link>
              <Link to="/circoli" className="btn btn--outline btn--lg">Trova il tuo circolo</Link>
            </div>
          </CtaSection>
        </div>
      </section>
    </Layout>
  );
};

export default ChiSiamoPage;
